<template>
  <div class="mt-3 row">
    <div class="col devices pe-2">
      <dashboard-tile>
        <h6 class="dashboard-tile-title border-bottom p-3 mb-0">{{ $t('flexigo.dashboard.telematicsDevices') }}</h6>
        <div class="box-content p-3">
          <div class="row">
            <div v-for="status in deviceStatuses" :key="status.marker" class="col">
              <dashboard-count-box
                class="device-status d-flex align-items-center justify-content-center"
                :value="status.count"
                :label="status.label"
                :link="false"
              >
                <template #marker>
                  <div class="dot" :class="status.marker"></div>
                </template>
              </dashboard-count-box>
            </div>
          </div>
        </div>
      </dashboard-tile>
    </div>
    <div class="col actions ps-2">
      <dashboard-tile>
        <h6 class="dashboard-tile-title border-bottom p-3 mb-0">{{ $t('flexigo.dashboard.actionRequired') }}</h6>
        <div class="box-content">
          <div class="row">
            <div class="col py-3 border-end">
              <div class="action-list ps-3">
                <table cellspacing="0" cellpadding="0" border="0">
                  <tbody>
                    <tr :class="{'has-cursor-pointer': actionsRequired.openTickets}"
                        v-on="actionsRequired.openTickets ? { click: () => direct('Tickets', 'nearbyStop') } : {}">
                      <td class="fitwidth text-end pe-2"><strong>{{ actionsRequired.openTickets || 0 }}</strong></td>
                      <td>{{ $t('flexigo.dashboard.openTickets') }}</td>
                    </tr>
                    <tr :class="{'has-cursor-pointer': actionsRequired.nearbyStopRequests}"
                        v-on="actionsRequired.nearbyStopRequests ? { click: () => direct('requestApprovalsGrid', 'nearbyStop') } : {}">
                      <td class="fitwidth text-end pe-2"><strong>{{ actionsRequired.nearbyStopRequests || 0 }}</strong></td>
                      <td>{{ $t('flexigo.dashboard.nearbyStopRequests') }}</td>
                    </tr>
                    <tr :class="{'has-cursor-pointer': actionsRequired.changeStopRequests}"
                        v-on="actionsRequired.changeStopRequests ? { click: () => direct('requestApprovalsGrid', 'routeChange') } : {}">
                      <td class="fitwidth text-end pe-2"><strong>{{ actionsRequired.changeStopRequests || 0 }}</strong></td>
                      <td>{{ $t('flexigo.dashboard.changeStopRequests') }}</td>
                    </tr>
                    <!-- <tr :class="{'has-cursor-pointer': actionsRequired.driversOverTheAgeLimit}"
                        v-on="actionsRequired.driversOverTheAgeLimit ? { click: () => direct('legacy') } : {}">
                      <td class="fitwidth text-end pe-2"><strong>{{ actionsRequired.driversOverTheAgeLimit  || 0 }}</strong></td>
                      <td>{{ $t('flexigo.dashboard.driversOverAgeLimit') }}</td>
                    </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col p-3">
              <div class="action-list">
                <table cellspacing="0" cellpadding="0" border="0">
                  <tbody>
                    <tr :class="{'has-cursor-pointer': actionsRequired.driverVehicleApproval}"
                        v-on="actionsRequired.driverVehicleApproval ? { click: () => direct('requestApprovalsGrid','vehicleDriverChange') } : {}">
                      <td class="fitwidth text-end pe-2"><strong>{{ actionsRequired.driverVehicleApproval || 0 }}</strong></td>
                      <td>{{ $t('flexigo.dashboard.driverVehicleApprovals') }}</td>
                    </tr>
                    <tr :class="{'has-cursor-pointer': actionsRequired.documentApprovals}"
                        v-on="actionsRequired.documentApprovals ? { click: () => direct('requestApprovalsGrid','documents') } : {}">
                      <td class="fitwidth text-end pe-2"><strong>{{ actionsRequired.documentApprovals || 0 }}</strong></td>
                      <td>{{ $t('flexigo.dashboard.documentApprovals') }}</td>
                    </tr>
                    <tr :class="{'has-cursor-pointer': actionsRequired.paymentApprovals}"
                        v-on="actionsRequired.paymentApprovals ? { click: () => direct('requestApprovalsGrid', 'payments') } : {}">
                      <td class="fitwidth text-end pe-2"><strong>{{ actionsRequired.paymentApprovals || 0 }}</strong></td>
                      <td>{{ $t('flexigo.dashboard.paymentApprovals') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </dashboard-tile>
    </div>
  </div>
</template>

<script>
import DashboardTile from './DashboardTile.vue';
import DashboardCountBox from './DashboardCountBox.vue';

export default {
  name: 'DevicesAndActions',
  components: { DashboardTile, DashboardCountBox },
  props: {
    telematics: {
      type: Object,
      required: true,
      default: () => {},
    },
    actionsRequired: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      window,
    };
  },
  computed: {
    // The device counts were links to the vehicle list once (directVehicles); they aren't for now.
    deviceStatuses() {
      return [
        { marker: 'dot-active', count: this.telematics.active, label: this.$t('flexigo.common.active') },
        { marker: 'dot-no-device', count: this.telematics.noDevice, label: this.$t('flexigo.dashboard.noDevice') },
        { marker: 'dot-no-connection', count: this.telematics.noConnection, label: this.$t('flexigo.dashboard.noConnection') },
      ];
    },
  },
  methods: {
    direct(comp, tab) {
      window.open(this.$router.resolve({ name: comp, query: { tab, lang: this.$i18n.locale }, params: { route: 'app.route.drivers' } }).href, '_blank');
    },
    directVehicles(deviceStatus) {
      this.$route.query.deviceStatus = deviceStatus;
      window.open(this.$router.resolve({ name: 'legacy', query: this.$route.query, params: { route: 'app.route.vehicles' } }).href, '_blank');
    },
  },
};
</script>
<style scoped>
.device-status {
   min-height: 86px;
}

.dot{
   border-radius: 50%;
    width: 12px;
    height: 12px;
    display: inline-block;
}
.dot-active {
   background-color: var(--color-progress);
}
.dot-no-device {
   background-color: var(--color-text-muted);
}
/* No token: --color-danger is a darker red. */
.dot-no-connection {
   background-color: #fc4848;
}
.action-list{
   height: 87px;
   overflow: auto;
}

td.fitwidth {
    width: 3rem;
    white-space: nowrap;
}
</style>
